/**
 * mqtt provider
 */
import mqtt from "./apis/mqtt";
import moment from "moment";
import { EventEmitter } from '../EventEmitter'
const com = 'Hexu'

let _online = true;
/**
 * @class MqttData
 * @classdesc mqtt服务
 */
export default class MqttData extends EventEmitter {
    topic = ``

    /**
     * 设备在线状态
     */
    get online() {
        return _online
    };
    set online(val) {
        _online = val;
        this.emit('online', val)
        if (val) {
            clearTimeout(this.stopTime)
        }
    }
    topicLast = ''; //一次只订阅一个主题
    timeout = 30000
    constructor(proc) {
        super()
        this.proc = proc;
        this.device = proc.data.device;
        this.mqtt = new mqtt();

        let data = proc.data;

        if (this.topicLast) {
            this.mqtt.unsubscribe({ topic: this.topicLast });
        }

        if (data.isLogined && this.device) {
            const deviceNO = this.device.deviceNo;
            this.topic = `${com}/${deviceNO}/DeviceSub`;
            this.subscribe(`${com}/${this.device.deviceNo}/DevicePub`)
            this.mqtt.on('connect', this.callback && this.callback);
        } else {
            // 监听device
            proc.watch('device', (val) => {
                if (!val) return;
                const deviceNO = val.deviceNo;
                this.topic = `${com}/${deviceNO}/DeviceSub`;
                this.device = val;
                this.subscribe(`${com}/${val.deviceNo}/DevicePub`)
                this.mqtt.on('connect', this.callback && this.callback);
            })
        }
        const subscribetopic = () => {
            this.mqtt.unsubscribe({
                topic: this.topic
            })
            this.subscribe(this.topic)
        }

        window.subscribeTopic = subscribetopic;

        this.mqtt.on('lost', () => {
            this.online = false;
            // this.getDeviceAllData()
            subscribetopic()
        })

        let firstSubscribe = true;

        // 订阅成功时获取所有的设备数据
        this.mqtt.on('subscribe.success', () => {
            if(firstSubscribe){
                this.getDeviceAllData()
                firstSubscribe = false;
            }
            if(!firstSubscribe && !this.proc.data.mqttData){
                this.getDeviceAllData()
            }
        })
        //保持心跳
        if (this.stop) {
            clearInterval(this.stop)
        }

        this.stop = setInterval(() => {
            
            this.mqtt.send('', '');
            
        }, 1000 *60)
    }

    /**
     * 发送消息
     * @param {obj} data 
     */
    sendMsg(data) {
        this.mqtt.send(this.topic, data);
    }
    // 订阅主题
    subscribe(topic) {
        return new Promise((resolve) => {
            this.mqtt.subscriptionApi({ topic },
                (data) => {
                    this.online = true;
                    this.proc.data.mqttData = data
                    this.emit('subscribe.success.mqtt', data)
                    resolve(data);

                }
            );
            this.topicLast = topic;
        });
    }

    subscribeTopic(topic) {
        return new Promise((resolve) => {
            this.mqtt.subscriptionApi({ topic },
                (data) => {
                    this.online = true;
                    resolve(data);
                }
            );
            this.topicLast = topic;
        });
    }


    stopTime = null;
    // 获取设备所有信息
    getDeviceAllData() {
        this.stopTime = setTimeout(() => {
            console.warn('连接超时，设备已离线');
            this.online = false;
        }, this.timeout)
        if (!this.device) return;
        this.mqtt.send(this.topic, {
            uuid: this.device.deviceNO,
            action: "readdata",
            ts: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
            data: "alldata",
        });
    }
}